<template>
  <div class="appPagination">
    <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :page-sizes="pageSizesArr"
        :total="total"
        :current-page="currentPage"
        :page-size="pageSize"
        :layout="layout"
        :background="background"
        :small="true"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "AppPagination",
  props: {
    // 总页数
    total: {
      type: Number,
      default: 0,
    },
    // 当前页
    currentPage: {
      type: Number,
      default: 1,
    },
    // 每页显示条数
    pageSize: {
      type: Number,
      default: 10,
    },
    background: {
      type: Boolean,
      default: true,
    },
    pageSizesArr: {
      type: Array,
      default() {
        return [10, 20, 30, 50];
      },
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
  },
  data() {
    return {
      page: {
        size: this.pageSize,
        page: this.currentPage,
      },
    };
  },
  methods: {
    //  每页查看条数变化
    handleSizeChange(val) {
      this.page.size = val;
      this.$emit("pageChange", this.page);
    },
    // 当前页码变化
    handleCurrentChange(val) {
      this.page.page = val;
      this.$emit("pageChange", this.page);
    },
  },
};
</script>

<style lang="scss" scoped>
.appPagination {
  margin-top: 30px;
  margin-bottom: 10px;
}
</style>
